export enum RewardTagsEnum {
	LEGALS_URL = 'legals url',
	START_DATE = 'start date',
	END_DATE = 'end date',
	PAYMENT_DATE = 'payment date',
	PAYMENT_LIMIT = 'payment limit',
	EXPIRATION_LIMIT = 'expiration limit',
	EXPERIENCE_EXPIRATION = 'experience expiration',
	SITE_NAME = 'site name',
	SITE_URL = 'site url',
	BANK_INFO_DATE = 'bank info date',
	GIFT_EXP = 'gift exp',
}
